export default [{"id":"1","startTime":0,"endTime":2976,"text":"<b>Danach folgt die Montage des Unterteils.</b>"}];